const SET_PROSPECT = 'SET_PROSPECT'
const CLEAR_PROSPECT = 'CLEAR_PROSPECT'

export default {
  SET_PROSPECT,
  CLEAR_PROSPECT
}



// WEBPACK FOOTER //
// ./src/actionTypes/onboarding/prospect.js